import { HStack, VStack } from '@terra/ui-styled-system';
import { Switch } from '../../components/switch';
import { BodyDefault } from '../../components/typography';
import { AutomationFieldLabel } from './AutomationFieldLabel';

export type AutomationToggleRowProps = {
  label: string;
  tooltipTitle: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  yesLabel: string;
  noLabel: string;
  disabled?: boolean;
};
export const AutomationToggleRow = ({
  label,
  tooltipTitle,
  checked,
  onCheckedChange,
  yesLabel,
  noLabel,
  disabled = false,
}: AutomationToggleRowProps) => {
  return (
    <VStack gap={2} alignItems="stretch">
      <AutomationFieldLabel label={label} tooltipTitle={tooltipTitle} />
      <HStack gap={2} alignItems="center">
        <Switch
          size="sm"
          checked={checked}
          disabled={disabled}
          onCheckedChange={(details) => onCheckedChange(details.checked)}
        />
        <BodyDefault color="fg.neutral.muted">
          {checked ? yesLabel : noLabel}
        </BodyDefault>
      </HStack>
    </VStack>
  );
};
